export const treatments = ['Criar', 'Armazenar', 'Acessar', 'Compartilhar', 'Arquivar', 'Destruir'];
